var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VehiclesHeader',{attrs:{"title":"Detalle de Vehículo"}}),_c('VehiclesForm',{attrs:{"vehicle":_vm.vehicle},on:{"onUpdate":_vm.onUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }